/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Artcraft_FilmInputs */

const en_fc_home_artcraft_film = /** @type {(inputs: Fc_Home_Artcraft_FilmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video editing`)
};

/**
* | output |
* | --- |
* | "Video editing" |
*
* @param {Fc_Home_Artcraft_FilmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_artcraft_film = /** @type {((inputs?: Fc_Home_Artcraft_FilmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Artcraft_FilmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_artcraft_film(inputs)
});
export { fc_home_artcraft_film as "fc.home.artcraft.film" }